import React, { useState } from "react";
import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { GetOrder } from "../../actions/orders";
import close from "../../assets/cancel.svg";
import PopupComponent from "../../common/Popup";
import Table from "../../common/Table";
import { amountFormat } from "../../config/helper";
import ShopForTyres from "../ShopForTyres";
import json2csv from 'json2csv';
import { saveAs } from "file-saver";
import { DownloadOutlined } from "@ant-design/icons";
import _ from "lodash";

const ProdDetailTable = ({ data, order, isEdit, products, setProducts, isPending, downloadIcon }) => {
  const [isShowProducts, setIsShowProducts] = useState(false);
  const dispatch = useDispatch();
  const columns = useMemo(() => {

    let arr = isPending ? [] : [{
      header: "Delivered Quantity",
      accessor: "DeliveredQty",
      width: 12,
    },
    {
      header: "Delivery Fill",
      accessor: "ZfillDel",
      width: 10,
    },
    ]
    return [
      {
        header: "IP Code",
        accessor: "SKU",
        width: 10,
      },
      {
        header: "SO Number",
        accessor: "SONumber",
        width: 10,
      },
      {
        header: "PO Number",
        accessor: "PONumber",
        width: 10,
      },
      {
        header: "Characteristics",
        accessor: "Pattern",
        width: 20,
      },
      ...arr,
      {
        header: "Unit Price",
        accessor: "Unit Price",
        width: 12,
        cell: (row) => `$${amountFormat(row?.["Unit Price"])}`,
      },
      {
        header: "Amount",
        accessor: "Amount",
        width: 10,
        cell: (row) => `$${amountFormat(row?.Amount)}`,
      },
    ]
    // eslint-disable-next-line 
  }, [isPending, data, order, products]);
  return (
    <div className="prod-detail p-relative">
      <button style={{
        position: "absolute",
        right: "2.5rem",
        top: "-2.5rem"
      }} onClick={() => {
        let prods = data?.map(ele => ({
          "IP Code": ele.SKU,
          "SO Number": ele.SONumber,
          "PO Number": ele.PONumber,
          "DO Number": ele.DeliveryNo,
          Characteristics: ele.Pattern,
          "Delivered Quantity": ele.DeliveredQty,
          "Delivery Fill": ele.ZfillDel,
          "Unit Price": ele["Unit Price"],
          Amount: ele.Amount,
        }));
        let csv = json2csv.parse(prods);
        var blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
        saveAs(blob, "ProductDetails.csv");
      }}>
        {downloadIcon ? downloadIcon : <><DownloadOutlined color="#333" />&nbsp; Download</>}
      </button>
      <Table
        columns={columns}
        data={data}
        showTotal={true}
        totalPrice={order?.total_price}
        totalQuantity={Array?.isArray(data) ? _.sumBy(data, "DeliveredQty") : 0}
        totalQtyText={"Total Delivered Quantity"}
        totalFill={data?.[0]?.ZfillTot ?? 0}
        isCancel={isEdit}
        delete={(id) => {
          let idx = data.findIndex((ele) => ele.id === id);
          if (idx > -1) {
            let prodId = data[idx].product_id;
            let prods = [...products];
            let idx1 = prods.findIndex((ele) => ele.product_id === prodId);
            if (idx1 > -1) {
              prods[idx].quantity = 0;
              setProducts(prods);
            }
          }
        }}
        orderEdit={isEdit}
        orderEditAction={() => {
          setIsShowProducts((bool) => !bool);
        }}
      />
      <PopupComponent open={isShowProducts} width={1400} height={580}
        className="table-popup"
      >
        <div>
          <img
            src={close}
            alt="close"
            width={20}
            style={{
              position: "absolute",
              right: 20,
              top: 10,
              cursor: "pointer",
            }}
            onClick={() => setIsShowProducts(false)}
          />
          <ShopForTyres
            noNav={true}
            fromOrder={true}
            fromOrderCart={(item) => {
              let obj = {
                product_id: item.id,
                quantity: parseInt(item.quantity),
              };
              dispatch({
                type: GetOrder.CHANGED,
                line_item: item,
              });
              let idx = products.findIndex((ele) => ele.product_id === item.id);
              if (idx > -1) {
                let prods = [...products];
                prods[idx].quantity = parseInt(item.quantity);
                setProducts(prods);
              } else {
                setProducts([...products, obj]);
              }
            }}
            line_items={data}
          />
        </div>
      </PopupComponent>
    </div>
  );
};

export default ProdDetailTable;
